import React, { useContext } from "react";
import pptpage from "../Driveanalysis_Bus/Drive_bus.pdf";
import DashboardMain_Bus from "../DashboardMain_Bus/DashboardMain_Bus";
import AppContext from '../../../store/AppContext';

function PPTPage_Bus() {
  const app_ctx = useContext(AppContext);
  return (
    <>
      <DashboardMain_Bus>
        <iframe src={pptpage} frameborder="0" height="539em" width="100%" sandbox></iframe>
      </DashboardMain_Bus>
    </>
  );
}

export default PPTPage_Bus;
